export function monthFromDate(date) {
  const key = (date && date.split('-')[1]) || '-';
  const months = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
    '-': ''
  };
  return months[key];
}

export function toDefaultDate(DDMMYYYY) {
  const split = DDMMYYYY.split('-'); // 05-03-2020
  const day = split[0];
  const month = split[1] - 1;
  const year = split[2];

  return new Date(year, month, day);
}



// WEBPACK FOOTER //
// ./src/assets/lib.js